import { Link as ReactDomLink } from 'react-router-dom';
import { MLink } from './';

export const MParentLink = ({
  parentLink,
  parentLinkTitle,
}: {
  parentLink?: string;
  parentLinkTitle?: string;
}) => {
  if (!(parentLink && parentLinkTitle)) {
    return null;
  }

  return (
    <MLink
      fontSize="sm"
      fontWeight="normal"
      asChild
      _hover={{
        textDecoration: 'underline',
      }}
    >
      <ReactDomLink to={parentLink}>{parentLinkTitle}</ReactDomLink>
    </MLink>
  );
};
